import Service from '../AuthService';

const Status = {
  getAllStatus() {
    return Service.get(`status`);
  }
};

export default Status;
